import axiosClient from "../axiosClient";

const route = "api/subCompany";

export const getFilteredSubcompanies = async (params) => {
  try {
    const response = await axiosClient.get(`${route}/forBank/byName`, {
      params: {
        page: params.page ?? 1,
        limit: params.limit ?? 5,
        search: params.search,
        organizationName: params.organizationName,
      },
    });

    return response;
  } catch (error) {}
};

export const getSubcompany = async (id) => {
  try {
    const response = await axiosClient.get(`${route}/${id}`);

    return response;
  } catch (error) {}
};

/**
 * Checks the blocked status of a subcompany for a bank account.
 * POST /api/bankBlock/isBlocked
 */
export const checkIfBlocked = async (subCompanyId, bankId) => {
  try {
    const response = await axiosClient.get(`${route}/isBlocked`, {
      params: {
        subCompanyId: subCompanyId,
        bankId: bankId,
      },
    });
    return response;
  } catch (error) {
    console.error("Error checking if blocked:", error);
    throw error;
  }
};
/**
 * Blocks a subcompany for a bank account.
 * POST /api/bankBlock/blockSubCompany
 */

/**
 * Unblocks a subcompany for a bank account.
 * POST /api/bankBlock/unblockSubCompany
 */
export const unblockSubCompany = async (subCompanyId, bankAccountId) => {
  try {
    const response = await axiosClient.post(`${route}/unblockSubCompany`, {
      subCompanyId,
      bankAccountId,
    });

    return response.data;
  } catch (error) {}
};
